import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import apiClient from '../api/axios';
import { toast } from 'react-toastify';

const CreateOrganizationModal = ({ show, onHide, onSuccess }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [isPublic, setIsPublic] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!show) {
            setName('');
            setDescription('');
            setIsPublic(false);
            setError(null);
        }
    }, [show]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await apiClient.post('/organizations/', {
                name,
                description: description || null,
                is_songs_library_public: isPublic
            });
            toast.success('Организация успешно создана!');
            if (onSuccess) {
                onSuccess(response.data);
            }
            onHide();
        } catch (err) {
            let errorMessage = 'Ошибка при создании организации.';
            if (err.response && err.response.data && err.response.data.detail) {
                errorMessage = err.response.data.detail;
            }
            setError(errorMessage);
            toast.error(errorMessage);
            console.error('Create organization error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Создать новую организацию</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formOrgName">
                        <Form.Label>Название организации</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Введите название"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formOrgDescription">
                        <Form.Label>Описание (необязательно)</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Введите описание"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Check
                            type="switch"
                            id="create-org-public-switch"
                            label="Опубликовать базу песен для всех"
                            checked={isPublic}
                            onChange={(e) => setIsPublic(e.target.checked)}
                        />
                    </Form.Group>

                    <Button variant="primary" type="submit" disabled={loading}>
                        {loading ? 'Создание...' : 'Создать'}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default CreateOrganizationModal;
